import clsx from "clsx";
import { createPortal } from "react-dom";
import Icon from "../Icon/Icon";
import styles from "./Loader.module.scss";

interface LoaderProps {
  portal?: boolean;
  className?: string;
}

const Loader = ({ portal, className }: LoaderProps) => {
  const LoaderComponent = (
    <div
      className={clsx(styles.loader, className, {
        [styles.portal]: portal,
      })}
    >
      <Icon icon="loader" className={styles.icon} />
    </div>
  );

  return portal
    ? createPortal(LoaderComponent, document.body)
    : LoaderComponent;
};

export default Loader;
